{
  "longPressMessage": "Håll nedtryckt för att öppna förhandsgranskningen"
}
